// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-Footer----footer-module---container---Xg_8o","footerdiv":"src-components-Footer----footer-module---footerdiv---120Ju","row":"src-components-Footer----footer-module---row---xjUv1","col":"src-components-Footer----footer-module---col---3uBDB"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/footer.module.css
// module id = 320
// module chunks = 114276838955818